import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TimeSlot from '../../components/ServiceRequestForm/TimeSlot';
import { CalendlyEventListener } from 'react-calendly';
import ServiceRequestTimeslotPicker from './ServiceRequestTimeslotPicker';
import Avatar from '../../components/Avatar/Avatar';
import { selectValidation } from 'src/store/selectors/Validation';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import {
  fetchAvailableServiceTimes,
  clearAvailableServiceTimes,
} from 'src/store/actions/availableServiceTimes';
import * as client from '../../services/client';
import Loader from '../../components/Loader';
import { clearValidation } from 'src/store/actions/suites';
import Button from '../../components/Button';
import Row from '../../components/Row';
import Col from '../../components/Col';
import { variables } from 'src/Tenants';
import './ScheduleWalkthroughComponent.scss';

interface ServiceRequestSchedulingProps {
  serviceRequest: any;
  onClose: () => void;
  onEventScheduled: (data: any) => void;
}

const ServiceRequestScheduling = ({
  serviceRequest,
  onClose,
  onEventScheduled,
}: ServiceRequestSchedulingProps) => {
  const [state, setState] = useState({
    slotSelected: false,
    scheduling_url: '',
    isLoading: false,
    scheduledAt: null,
  });

  const dispatch = useDispatch();

  const availableServiceTimes: any = useSelector(
    (state: any) => state.availableServiceTimes
  );

  const validation: any = useSelector(selectValidation);
  const loader: any = useSelector(selectFormLoader);

  useEffect(() => {
    dispatch(clearAvailableServiceTimes() as any);
    setState((prev: any) => ({ ...prev, isLoading: true }));
    client
      .fetchCalendlyLink(serviceRequest.serviceProvider.email)
      .then((response: any) => {
        if (response.ok || response.status === 200) {
          response.json().then((responseJson) => {
            if (responseJson.statusCode === 200) {
              if (
                responseJson &&
                responseJson.data &&
                responseJson.data.calendarLink &&
                responseJson.data.calendlyAPIKey
              ) {
                setState((prev: any) => ({
                  ...prev,
                  scheduling_url: responseJson.data.calendarLink,
                  isLoading: false,
                }));
              } else {
                setState((prev: any) => ({
                  ...prev,
                  scheduling_url: '',
                  isLoading: false,
                }));
              }
            } else if (responseJson.statusCode === 400) {
              setState((prev: any) => ({
                ...prev,
                scheduling_url: '',
                isLoading: false,
              }));
            }
          });
        } else {
          setState((prev: any) => ({
            ...prev,
            scheduling_url: '',
            isLoading: false,
          }));
        }
      });
  }, []);

  useEffect(() => {
    if (validation.status === true) {
      if (validation.message === 'Schedule') {
        onClose();
        dispatch(clearValidation() as any);
      }
    }
  }, [validation, onClose, dispatch]);

  const selectTimeSlot = (selectedState: string) => {
    const servicePreferences: any[] = [];

    let theme = localStorage.getItem('theme');

    if (theme === 'Albaster') {
      let selectedSlots = selectedState.split(',');

      selectedSlots.map((slot) => {
        let slots = slot.split(' ');
        if (slot.includes('7:30 - 11:30')) {
          servicePreferences.push(slots[0] + ':' + '7am-11am');
        } else if (slot.includes('11:30 - 3:30')) {
          servicePreferences.push(slots[0] + ':' + '11am-3pm');
        } else {
          servicePreferences.push(slots[0] + ':' + 'all day');
        }
      });

      dispatch(
        fetchAvailableServiceTimes(
          serviceRequest?.serviceProvider?.id,
          servicePreferences
        ) as any
      );

      setState((prev) => ({ ...prev, slotSelected: true }));
    } else {
      const servicePreferences: any[] = [];

      var array = selectedState.split(',');

      array.map((slot) => {
        let slots = slot.split(' ');
        servicePreferences.push(slots[0] + ':' + slots[1]);
      });

      dispatch(
        fetchAvailableServiceTimes(
          serviceRequest?.serviceProvider?.id,
          servicePreferences
        ) as any
      );

      setState((prev) => ({ ...prev, slotSelected: true }));
    }
  };

  const CalendlyListener = CalendlyEventListener as any;

  return (
    <>
      <div className="header">
        <div className="top_coner_box">
          <div className="close_icon" onClick={onClose}>
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22 0.125C9.8125 0.125 0.125 9.8125 0.125 22C0.125 34.1875 9.8125 43.875 22 43.875C34.1875 43.875 43.875 34.1875 43.875 22C43.875 9.8125 34.1875 0.125 22 0.125ZM30.4375 32.9375L22 24.5L13.5625 32.9375L11.0625 30.4375L19.5 22L11.0625 13.5625L13.5625 11.0625L22 19.5L30.4375 11.0625L32.9375 13.5625L24.5 22L32.9375 30.4375L30.4375 32.9375Z"
                fill="#797979"
              />
            </svg>
          </div>
          <svg
            width="156"
            height="201"
            viewBox="0 0 156 201"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              opacity="0.11"
              cx="170"
              cy="31"
              r="135"
              stroke="#48C1BF"
              strokeWidth="70"
            />
          </svg>
        </div>
      </div>
      <div
        className="walkthrough_section WalkthroughScroll"
        style={{ width: '98%' }}
      >
        <div className="wrapper">
          <div className="walthrough_box">
            <div className="title_heading text-center">
              <h2>Schedule Service Request</h2>
            </div>
            <div className="walthrough_table_box">
              <table>
                <thead>
                  <tr>
                    <th>Property Name</th>
                    <th className="line_table">
                      <div className="line_table_line"></div>
                    </th>
                    <th>Property Address</th>
                    <th className="line_table">
                      <div className="line_table_line"></div>
                    </th>
                    <th>{variables.Suite} </th>
                    <th className="line_table">
                      <div className="line_table_line"></div>
                    </th>
                    <th>Home Owner</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td data-title="Property Name">
                      {serviceRequest?.suite?.property?.name}
                    </td>
                    <td className="line_table">
                      <div className="line_table_line"></div>
                    </td>
                    <td data-title="Property Address">
                      <p>
                        {serviceRequest?.suite?.property?.propertyAddress
                          ?.addressLine1 +
                          ', ' +
                          serviceRequest?.suite?.property?.propertyAddress
                            ?.city +
                          ' ' +
                          serviceRequest?.suite?.property?.propertyAddress
                            ?.postalCode}{' '}
                      </p>
                    </td>
                    <td className="line_table">
                      <div className="line_table_line"></div>
                    </td>
                    <td data-title="Suite">{serviceRequest?.suite?.number}</td>
                    <td className="line_table">
                      <div className="line_table_line"></div>
                    </td>
                    <td data-title="Home Owner">
                      <div className="profile_box">
                        <Avatar
                          url={serviceRequest?.suite?.homeOwner?.profileImage}
                        />
                        <span style={{ marginLeft: '5px' }}>
                          {serviceRequest?.suite?.homeOwner?.name}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {state.isLoading || loader ? (
              <Loader center={true} />
            ) : (
              <div className="preferred_appointment_times">
                <div className="title text-center">
                  <h3>Preferred appointment times</h3>
                </div>
                <div className="calender_box">
                  {state.scheduling_url ? (
                    <div className="walkthroughTimeSlot walkthroughTimeSlot1">
                      <Row>
                        <Col xs="12" md="6">
                          <TimeSlot
                            fromScheduling={
                              serviceRequest.preferredServiceTimes
                            }
                            handleSelectionFormData={(selectedState) =>
                              selectTimeSlot(selectedState)
                            }
                          />
                        </Col>
                        <Col xs="12" md="6">
                          <CalendlyListener
                            onEventScheduled={(e: any) => {
                              let uri = e.data.payload?.event.uri;
                              let eventId = uri.split('/').pop();
                              onEventScheduled({
                                name: 'Scheduled',
                                EventId: eventId,
                              });
                            }}
                          >
                            <div
                              style={{
                                height: '85vh',
                                width: '50vw',
                                backgroundColor: '#fbfcfd',
                              }}
                            >
                              <iframe
                                src={
                                  state.scheduling_url +
                                  `?embed_domain=tcampb.github.io&embed_type=Inline&name=${
                                    serviceRequest?.suite?.property
                                      ?.propertyManagers[0].name
                                  }&email=${serviceRequest?.suite?.property?.propertyManagers[0].email}`
                                }
                                width="100%"
                                height="100%"
                                frameBorder="0"
                              />
                            </div>
                          </CalendlyListener>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <>
                      <div className="walkthroughTimeSlot sr-scheduling-slots">
                        <TimeSlot
                          from="srscheduling"
                          fromScheduling={serviceRequest.preferredServiceTimes}
                          handleSelectionFormData={(selectedState) =>
                            selectTimeSlot(selectedState)
                          }
                        />
                        <div className="sr-scheduling-picker">
                          {!state.slotSelected ? (
                            <></>
                          ) : (
                            <ServiceRequestTimeslotPicker
                              availableServiceTimes={availableServiceTimes}
                              setFormData={(e) =>
                                setState((prev) => ({
                                  ...prev,
                                  scheduledAt: e?.scheduledAt,
                                }))
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <Button
                          label="Schedule"
                          color="teal"
                          size="small"
                          disabled={!state.scheduledAt}
                          onClick={(e) =>
                            onEventScheduled({
                              name: 'Scheduled',
                              scheduledAt: state.scheduledAt,
                            })
                          }
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceRequestScheduling;
